import axios from 'axios';

// Recensioni dei clienti del sito (Sito ecommerce -> Recensioni): stanno dentro i prodotti
// (item.reviews.lists), il backend le legge tutte insieme (features/reviews).

const buildUrl = (context, path = '') => `${context.rootGetters['settings/getUrl']}reviews${path}`;

const authHeader = context => ({ Authorization: `Bearer ${context.rootGetters['profile/getToken']}` });

const fail = err => {
	const detail = err?.response?.data?.error;
	return {
		error: Array.isArray(detail) ? detail.map(e => (typeof e === 'string' ? e : e.msg || e.param)).join(', ') : detail || err?.response?.status || true,
		status: err?.response?.status,
	};
};

const actions = {
	// elenco + riepilogo (media, totale, stelle) del periodo
	list: (context, settings) => {
		const { filters = {}, options = {}, search = '' } = settings || {};
		const params = {
			stars: (filters.stars || []).join(',') || undefined,
			visibility: filters.visibility || undefined,
			from: filters.from || undefined,
			to: filters.to || undefined,
			search: search || undefined,
			page: options.page || 1,
			limit: options.itemsPerPage || 25,
		};
		return axios
			.get(buildUrl(context), { headers: authHeader(context), params })
			.then(res => res.data)
			.catch(fail);
	},

	// mostra o nasconde la recensione sul sito (la media del prodotto si ricalcola)
	setActive: (context, { itemId, reviewId, active }) =>
		axios
			.patch(buildUrl(context, `/${itemId}/${reviewId}/active`), { active }, { headers: authHeader(context) })
			.then(res => res.data)
			.catch(fail),
};

export default {
	namespaced: true,
	actions,
};
